// Generated by purs version 0.15.15
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Halogen_Styled from "../Halogen.Styled/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var debug = function (name) {
    return function (r) {
        if (r.context.debug) {
            return {
                extraClasses: r.extraClasses,
                inlineStyles: r.inlineStyles,
                styleSheets: r.styleSheets,
                context: r.context,
                name: name,
                props: append(r.props)([ Halogen_HTML_Properties.attr("data-label")(name) ])
            };
        };
        return r;
    };
};
var styleLeaf = function (leaf) {
    return function (name) {
        return function (opts) {
            return Halogen_Styled.styleLeaf(leaf)(append([ debug(name) ])(opts));
        };
    };
};
var styleNode = function (node) {
    return function (name) {
        return function (opts) {
            return Halogen_Styled.styleNode(node)(append([ debug(name) ])(opts));
        };
    };
};
var styleNodeKeyed = function (nodeKeyed) {
    return function (name) {
        return function (opts) {
            return Halogen_Styled.styleNodeKeyed(nodeKeyed)(append([ debug(name) ])(opts));
        };
    };
};
export {
    styleLeaf,
    styleNode,
    styleNodeKeyed
};
//# sourceMappingURL=index.js.map
